import { Cellar } from '../types';

interface CellarListProps {
  cellars: Cellar[];
  currentUserId: string;
  onSelectCellar: (cellar: Cellar) => void;
}

export function CellarList({ cellars, currentUserId, onSelectCellar }: CellarListProps) {
  if (cellars.length === 0) {
    return (
      <div className="ios-card" style={{ padding: '32px 16px', textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '12px' }}>🍷</div>
        <p className="wine-title" style={{ 
          fontSize: '18px', 
          color: 'var(--color-text)',
          marginBottom: '4px'
        }}>
          No cellars yet
        </p>
        <p style={{ fontSize: '14px', color: 'var(--color-text-muted)' }}>
          Create your first cellar to start tracking wines
        </p>
      </div>
    );
  }

  return (
    <div className="ios-card" style={{ overflow: 'hidden' }}>
      {cellars.map((cellar, index) => (
        <div
          key={cellar.id}
          onClick={() => onSelectCellar(cellar)}
          className="ios-list-row"
          style={{ 
            cursor: 'pointer',
            padding: '14px 16px',
            borderBottom: index < cellars.length - 1 ? '1px solid var(--color-border)' : 'none'
          }}
        >
          {/* Icon */}
          <span style={{ fontSize: '24px' }}>🍷</span>
          
          {/* Cellar info */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span 
                className="wine-title" 
                style={{ 
                  fontSize: '17px', 
                  color: 'var(--color-text)'
                }}
              >
                {cellar.name}
              </span>
              {cellar.owner_id !== currentUserId && (
                <span className="badge badge-blue">Shared</span>
              )}
            </div>
            {cellar.description && (
              <p style={{ 
                fontSize: '14px', 
                color: 'var(--color-text-muted)',
                marginTop: '2px'
              }}>
                {cellar.description}
              </p>
            )}
          </div>
          
          {/* Chevron */}
          <span style={{ fontSize: '18px', color: 'var(--color-border)' }}>›</span>
        </div>
      ))}
    </div>
  );
}
